import { render, staticRenderFns } from "./ApplyNote.vue?vue&type=template&id=0c0a4d04&scoped=true"
import script from "./ApplyNote.vue?vue&type=script&lang=js"
export * from "./ApplyNote.vue?vue&type=script&lang=js"
import style0 from "./ApplyNote.vue?vue&type=style&index=0&id=0c0a4d04&prod&lang=scss&scoped=true"
import style1 from "./ApplyNote.vue?vue&type=style&index=1&id=0c0a4d04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a4d04",
  null
  
)

export default component.exports